export default __webpack_public_path__ + "static/media/stopwatch.2e502f89.svg";